import Axios from "axios";
import ToolCode from "./ToolCode";
export default {
  name: "ToolCommon",
  components: {
    ToolCode: ToolCode
  },
  data: function data() {
    return {
      // 工具1: 查询产品ID所属系统
      loading_sn: false,
      productId: '',
      productSn: []
    };
  },
  methods: {
    findSn: function findSn() {
      var _this = this;
      this.loading_sn = true;
      Axios.get("/pmv5/service/activation/find-sn/".concat(this.productId, "/")).then(function (resp) {
        var _resp$data = resp.data,
          code = _resp$data.code,
          data = _resp$data.data;
        if (code !== 0) {
          return;
        }
        _this.productSn.splice(0);
        data.map(function (item) {
          for (var key in item) {
            _this.productSn.push({
              name: key,
              desc: item[key]
            });
          }
        });
      }).finally(function () {
        _this.loading_sn = false;
      });
    }
  }
};